import { render } from "./AppDate.vue?vue&type=template&id=d023643a"
import script from "./AppDate.vue?vue&type=script&lang=js"
export * from "./AppDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__